/**
 * services/presets/presets.ts — preset bundles (list, manifest, install).
 */
import { axiosInstance, unwrap, withFallback } from '../client';
import { Upsell_Presets_Url, Upsell_Preset_Url, Upsell_Preset_Install_Url } from '../../api-endpoints/endpoints';
import { PresetSummary, PresetDetail, InstallResult } from '../../schema/preset';
import { Seed } from '../_demo/seed';
import { getDemoVertical } from '../_demo/verticalStore';

export function listPresets(): Promise<PresetSummary[]> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.get(Upsell_Presets_Url);
      return unwrap<PresetSummary[]>(data);
    },
    () => Seed.presets(getDemoVertical()),
  );
}

export function getPreset(key: string): Promise<PresetDetail> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.get(Upsell_Preset_Url(key));
      return unwrap<PresetDetail>(data);
    },
    () => {
      const seed = Seed.presetDetail(key);
      if (!seed) throw new Error('preset_not_found');
      return seed;
    },
  );
}

export function installPreset(key: string): Promise<InstallResult> {
  return withFallback(
    async () => {
      const { data } = await axiosInstance.post(Upsell_Preset_Install_Url(key));
      return unwrap<InstallResult>(data);
    },
    () => ({ installed: Seed.presetDetail(key)?.rules.length ?? 0, deferred: 0 }),
  );
}
